import { render, staticRenderFns } from "./Imofalform2Grid.vue?vue&type=template&id=63462953"
import script from "./Imofalform2Grid.vue?vue&type=script&lang=js"
export * from "./Imofalform2Grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports